export default __webpack_public_path__ + "static/media/truescope-logo-no-padding.7841d669.png";